import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReturnOrdersParams, TypeGetReturnOrdersResponse } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [반품 신청/조회] 반품 신청 리스트 조회 api 요청 훅
 */
const useGetReturnOrders = () => {
  const { runAsync } = useAsyncHandler();

  const getReturnOrders = useAPI<TypeGetReturnOrdersParams, TypeGetReturnOrdersResponse>({
    endpoint: API_ENDPOINT.CLAIM.GET_RETURN_ORDERS,
    method: 'get',
  });

  const requestReturnOrders = async (
    params: TypeGetReturnOrdersParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetReturnOrdersResponse) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getReturnOrders({ params }), {
      onSuccess: (data) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestReturnOrders };
};

export default useGetReturnOrders;
